module.exports = __webpack_public_path__ + "img/the_sixth_amulet.ab778f64.jpg";